import { useQuery, useMutation } from '@tanstack/react-query';
import { trpc, queryClient } from '@/lib/trpc';

// Define our own Organization type here to avoid circular imports
interface Organization {
  id: string;
  name: string;
  slug: string | null;
  logo: string | null;
  createdAt: string | Date;
  updatedAt: string | Date;
  metadata: string | null;
  product: string
  mfaRequired?: boolean
  mfaGraceEndsAt?: string | Date | null
}

interface UseActiveOrganizationResult {
  organization: Organization | null;
  isLoading: boolean;
  error: Error | null;
  setActiveOrganization: (organizationId: string) => Promise<void>;
}

export function useActiveOrganization(): UseActiveOrganizationResult {
  // Get the active organization
  const { data, isLoading, error } = useQuery(
    trpc.organizations.getActiveOrganization.queryOptions()
  );
  
  // Mutation to set active organization
  const { mutateAsync } = useMutation(
    trpc.organizations.setActiveOrganization.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            'organizations',
            'getActiveOrganization'
          ]
        });
      }
    })
  );

  const setActiveOrganization = async (organizationId: string) => {
    await mutateAsync({ organizationId });
  };

  return {
    organization: data?.organization || null,
    isLoading,
    error: error as Error | null,
    setActiveOrganization,
  };
} 
